














































































































import { Vue, Prop, Model, Component } from 'vue-property-decorator'
import { Operador } from '@/models/venda/Operador'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { MetaDiaria } from '@/models/MetaDiaria'
import { FindMetaDiariaUseCase } from '@/usecases/metaDiaria/FindMetaDiariaUseCase';
import { SaveMetaDiariaUseCase } from '@/usecases/metaDiaria/SaveMetaDiariaUseCase';
import type { Meta } from '@/models';
import { formatarMoeda } from '@/shareds/formatadores';

@Component
export default class DialogoMetaDiaria extends Vue {
	@Model('input', { type: Boolean }) readonly value!: boolean
	@Prop({ type: Object, default: null }) vendedorSelecionado!: Operador | null
	@Prop({ type: Object, default: null }) meta!: Meta
	saveUseCase = new SaveMetaDiariaUseCase()
	findUseCase = new FindMetaDiariaUseCase()

	formatarMoeda = formatarMoeda

	dialogKey = 0
	metaDiaria: MetaDiaria | null = null
	carregando = false
	erro: any | Error = null
	valorMeta: number | null = null
	percentualMeta: number | null = null
	valorSuperMetaLocal: number | null = null
	percentualSuperMetaLocal: number | null = null

	mostrarDialogoDiaSelecionado = false
	diaSelecionado: string | null = null
	$refs!: {
		calendar: any
	}
	dataAtual: string = new Date().toISOString().substr(0, 10) // YYYY-MM-DD
	eventos: any = []

	menuAcao = false
	menuX = 0
	menuY = 0
	eventoSelecionado: any = null
	_skipDayClick = false

	mostrarLimparPeriodo = false
	periodoStart = ''
	periodoEnd = ''
	limpandoPeriodo = false

	get mostrar() {
		return this.value
	}
	set mostrar(val: boolean) {
		this.$emit('input', val)
	}

	async fechar() {
		// Usa o primeiro/último dia do mês atual (não o range do grid, que inclui dias de meses adjacentes)
		const ref = this.dataAtual || this.$refs.calendar?.lastStart?.date || ''
		const [year, month] = ref.split('-').map(Number)
		const firstDay = `${year}-${String(month).padStart(2, '0')}-01`
		const lastDay = new Date(year, month, 0).toISOString().slice(0, 10)

		const valorTotalMetasDiarias = await this.findUseCase
			.getValorTotalMetasDiarias(this.meta.id, firstDay, lastDay)

		if (this.meta.valor != valorTotalMetasDiarias) {
			AlertModule.setWarning(
				`A meta do mês com valor diferente do total das metas diárias: R$ ${formatarMoeda(valorTotalMetasDiarias)}`,
			)
		}

		this.mostrar = false
		this.dialogKey++
		this.dataAtual = ""
	}

	onSelecionarDia({ date, nativeEvent }: { date: string; nativeEvent?: MouseEvent }) {
		if (this._skipDayClick) return
		const eventoExistente = this.eventos.find((ev: any) => ev.start === date)
		if (eventoExistente?.metaDiaria) {
			this.metaDiaria = eventoExistente.metaDiaria
			this.valorMeta = eventoExistente.metaDiaria.valor ?? 0
			this.percentualMeta = eventoExistente.metaDiaria.percentual ?? 0
			this.valorSuperMetaLocal = eventoExistente.metaDiaria.valorSuperMeta ?? 0
			this.percentualSuperMetaLocal = eventoExistente.metaDiaria.percentualSuperMeta ?? 0
		} else {
			this.metaDiaria = null
			this.valorMeta = null
			this.percentualMeta = null
			this.valorSuperMetaLocal = null
			this.percentualSuperMetaLocal = null
		}
		this.diaSelecionado = date
		this.mostrarDialogoDiaSelecionado = true
	}

	onClickChip({ event, nativeEvent }: { event: any; nativeEvent: MouseEvent }) {
		nativeEvent.stopPropagation()
		this._skipDayClick = true
		// click:event passes the Vuetify-parsed event; the original is in event.input
		this.eventoSelecionado = event.input ?? event
		this.menuX = nativeEvent.clientX
		this.menuY = nativeEvent.clientY
		this.$nextTick(() => {
			this.menuAcao = true
			this._skipDayClick = false
		})
	}

	abrirEdicao() {
		if (!this.eventoSelecionado) return
		const ev = this.eventoSelecionado
		this.metaDiaria = ev.metaDiaria ?? null
		this.valorMeta = ev.metaDiaria?.valor ?? 0
		this.percentualMeta = ev.metaDiaria?.percentual ?? 0
		this.valorSuperMetaLocal = ev.metaDiaria?.valorSuperMeta ?? 0
		this.percentualSuperMetaLocal = ev.metaDiaria?.percentualSuperMeta ?? 0
		this.diaSelecionado = ev.start
		this.mostrarDialogoDiaSelecionado = true
	}

	async limparDia(event: any) {
		if (!event?.metaDiaria) return
		try {
			this.metaDiaria = event.metaDiaria
			this.diaSelecionado = event.start
			this.valorMeta = 0
			this.percentualMeta = event.metaDiaria.percentual ?? 0
			this.valorSuperMetaLocal = 0
			this.percentualSuperMetaLocal = event.metaDiaria.percentualSuperMeta ?? 0
			await this.salvarMetaDiaria()
			AlertModule.setSuccess('Dia limpo e valor redistribuído.')
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	async limparDiaDoMenu() {
		await this.limparDia(this.eventoSelecionado)
	}

	async confirmarLimparPeriodo() {
		if (!this.periodoStart || !this.periodoEnd || !this.vendedorSelecionado) return
		const start = this.periodoStart
		const end = this.periodoEnd
		if (start > end) {
			AlertModule.setError('Data início deve ser anterior à data fim.')
			return
		}

		const noPeriodo = this.eventos.filter(
			(ev: any) => ev.start >= start && ev.start <= end && Number(ev.metaDiaria?.valor) > 0,
		)
		if (noPeriodo.length === 0) {
			AlertModule.setInfo('Nenhum dia com meta nesse período.')
			return
		}

		const totalClearado = noPeriodo.reduce((s: number, ev: any) => s + Number(ev.metaDiaria.valor), 0)
		const totalSuperMetaClearado = noPeriodo.reduce(
			(s: number, ev: any) => s + (Number(ev.metaDiaria.valorSuperMeta) || 0), 0,
		)

		const remaining = this.eventos.filter(
			(ev: any) => (ev.start < start || ev.start > end) && Number(ev.metaDiaria?.valor) > 0,
		)
		const adicionalPorDia = remaining.length > 0 ? totalClearado / remaining.length : 0
		const superMetaAdicionalPorDia = remaining.length > 0 && totalSuperMetaClearado > 0
			? totalSuperMetaClearado / remaining.length
			: null

		const itensClearados = noPeriodo.map((ev: any) => ({
			metaId: this.meta.id,
			vendedorId: this.vendedorSelecionado!.id,
			data: (ev.metaDiaria.data || ev.start || '').slice(0, 10),
			valor: 0,
			percentual: ev.metaDiaria.percentual ?? this.meta.comissao ?? 0,
			valorSuperMeta: 0,
			percentualSuperMeta: ev.metaDiaria.percentualSuperMeta ?? this.meta.comissaoSuperMeta ?? null,
		}))

		const itensRestantes = remaining.map((ev: any) => ({
			metaId: this.meta.id,
			vendedorId: this.vendedorSelecionado!.id,
			data: (ev.metaDiaria.data || ev.start || '').slice(0, 10),
			valor: Number(ev.metaDiaria.valor) + adicionalPorDia,
			percentual: ev.metaDiaria.percentual ?? this.meta.comissao ?? 0,
			valorSuperMeta: superMetaAdicionalPorDia != null
				? (Number(ev.metaDiaria.valorSuperMeta) || 0) + superMetaAdicionalPorDia
				: ev.metaDiaria.valorSuperMeta ?? null,
			percentualSuperMeta: ev.metaDiaria.percentualSuperMeta ?? this.meta.comissaoSuperMeta ?? null,
		}))

		try {
			this.limpandoPeriodo = true
			// Inclui dias zerados no batch para garantir que o range delete os cobre
			await this.saveUseCase.salvarBatch([...itensClearados, ...itensRestantes])
			await this.atualizaCalendario(this.$refs.calendar.lastStart, this.$refs.calendar.lastEnd)
			this.mostrarLimparPeriodo = false
			AlertModule.setSuccess(`${noPeriodo.length} dia(s) limpo(s) e valor redistribuído.`)
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.limpandoPeriodo = false
		}
	}

	async atualizaCalendario(start: any, end: any) {
		if (!this.vendedorSelecionado) {
			this.eventos = []
			return
		}
		try {
			this.carregando = true
			const metasDiarias = await this.findUseCase.findByUserAndRange(
				this.meta.id,
				this.vendedorSelecionado.id,
				start.date,
				end.date,
			)
			this.eventos = metasDiarias
				.filter(meta => Number(meta.valor) > 0)
				.map(meta => ({
					name: `R$ ${formatarMoeda(meta.valor)}`,
					start: meta.data.slice(0, 10),
					color: 'purple',
					timed: false,
					metaDiaria: meta,
				}))
		} catch (e) {
			this.eventos = []
			this.erro = e
			AlertModule.setError(e)
		} finally {
			this.carregando = false
		}
	}

	prev() {
		if (this.$refs.calendar) {
			this.$refs.calendar.prev()
		}
	}
	next() {
		if (this.$refs.calendar) {
			this.$refs.calendar.next()
		}
	}

	async updateRange({ start, end }: { start: any; end: any }) {
		await this.atualizaCalendario(start, end)
	}

	async salvarMetaDiaria() {
		if (!this.vendedorSelecionado || !this.diaSelecionado) {
			AlertModule.setError('Selecione um vendedor e um dia.')
			return
		}
		if (this.valorMeta === null || this.percentualMeta === null) {
			AlertModule.setError('Preencha os campos de valor e percentual.')
			return
		}

		const metaDiaria: MetaDiaria = {
			...this.metaDiaria,
			data: this.diaSelecionado,
			valor: this.valorMeta,
			percentual: this.percentualMeta,
			valorSuperMeta: this.valorSuperMetaLocal ?? null,
			percentualSuperMeta: this.percentualSuperMetaLocal ?? null,
			vendedor: this.vendedorSelecionado,
			meta: this.meta,
		}
		const updatedMetaDiaria = await this.saveUseCase.update(metaDiaria)
		metaDiaria.id = updatedMetaDiaria.id
		const idx = this.eventos.findIndex(
			(ev: any) => ev.start === this.diaSelecionado,
		)
		if (idx !== -1) {
			this.eventos[idx] = {
				...this.eventos[idx],
				name: `R$ ${formatarMoeda(this.valorMeta)}`,
				metaDiaria: metaDiaria,
				color: 'purple',
			}
		}
		this.mostrarDialogoDiaSelecionado = false

		// Valor zerado: remove chip do dia e redistribui o valor desse dia nos demais
		if (this.valorMeta === 0) {
			const valorClearado = Number(this.metaDiaria?.valor ?? 0)
			const superMetaClearado = this.metaDiaria?.valorSuperMeta != null
				? Number(this.metaDiaria.valorSuperMeta)
				: null
			this.eventos = this.eventos.filter((ev: any) => ev.start !== this.diaSelecionado)
			const diasComMeta = this.eventos.filter(
				(ev: any) => ev.metaDiaria != null && ev.metaDiaria.valor > 0,
			)
			if (diasComMeta.length > 0 && valorClearado > 0) {
				const adicionalPorDia = valorClearado / diasComMeta.length
				const superMetaAdicionalPorDia = superMetaClearado != null
					? superMetaClearado / diasComMeta.length
					: null
				const itens = diasComMeta.map((ev: any) => ({
					metaId: this.meta.id,
					vendedorId: this.vendedorSelecionado!.id,
					data: (ev.metaDiaria.data || ev.start || '').slice(0, 10),
					valor: Number(ev.metaDiaria.valor) + adicionalPorDia,
					percentual: ev.metaDiaria.percentual ?? this.meta.comissao ?? 0,
					valorSuperMeta: superMetaAdicionalPorDia != null
						? (Number(ev.metaDiaria.valorSuperMeta) || 0) + superMetaAdicionalPorDia
						: ev.metaDiaria.valorSuperMeta ?? null,
					percentualSuperMeta: ev.metaDiaria.percentualSuperMeta ?? this.meta.comissaoSuperMeta ?? null,
				}))
				await this.saveUseCase.salvarBatch(itens)
			}
			// Reload para pegar IDs frescos do BD (batch delete+insert gera novos UUIDs)
			await this.atualizaCalendario(this.$refs.calendar.lastStart, this.$refs.calendar.lastEnd)
			return
		}
		this.eventos = [...this.eventos]
	}
}
